import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';
import { useMapsAddress } from '../../address-form.hooks';

const StreetAddress2Field = ({ name, ...rest }) => {
  const { t } = useTranslation();
  useMapsAddress(name, 'streetAddress2');

  return (
    <IncTextField
      name={name}
      placeholder={t('forms.fields.streetAddress2.placeholder')}
      data-testid="StreetAddress2Field"
      {...rest}
    />
  );
};
export default StreetAddress2Field;
